export var VehicleImageType;
(function (VehicleImageType) {
    VehicleImageType["SCRATCH_FRONT"] = "SCRATCH_FRONT";
    VehicleImageType["SCRATCH_BACK"] = "SCRATCH_BACK";
    VehicleImageType["SCRATCH_LEFT"] = "SCRATCH_LEFT";
    VehicleImageType["SCRATCH_RIGHT"] = "SCRATCH_RIGHT";
    VehicleImageType["GENERAL"] = "GENERAL";
    VehicleImageType["FUEL"] = "FUEL";
})(VehicleImageType || (VehicleImageType = {}));
